// Întrebări frecvente homepage - SURSĂ UNICĂ pentru FAQ.jsx (vizibil) și SchemaMarkup.jsx (FAQPage)
// Modifici aici → se actualizează ambele (evită diferențe între textul vizibil și schema).
const homeFaq = [
  {
    question: 'Cât durează să primesc extrasul de carte funciară?',
    answer: 'În majoritatea cazurilor primești extrasul pe email în aproximativ 5 minute de la confirmarea plății. Rar, când cartea funciară a imobilului nu este încă disponibilă în format electronic, emiterea poate dura până la 2 zile lucrătoare. Te anunțăm pe email dacă apare o întârziere.'
  },
  {
    question: 'Extrasul este un document oficial?',
    answer: 'Da. Primești extrasul oficial de carte funciară pentru informare, în format PDF, emis de instituția de cadastru și semnat electronic. Este acceptat de notari, bănci, avocați, primării și instanțe.'
  },
  {
    question: 'Ce date îmi trebuie ca să comand?',
    answer: 'Ai nevoie de județ, localitate (UAT) și numărul cadastral sau numărul de carte funciară al imobilului. Pentru apartamente, identificatorul are de obicei forma 12345-C1-U3. Nu ai nevoie de cont și nu trebuie să fii proprietarul imobilului.'
  },
  {
    question: 'Pot cere extras pentru un imobil care nu este al meu?',
    answer: 'Da. Cartea funciară este publică, deci poți cere extras pentru orice imobil înscris: o casă pe care vrei să o cumperi, un teren învecinat sau imobilul unui partener de afaceri. Este exact situația în care extrasul te ajută cel mai mult.'
  },
  {
    question: 'Ce conține extrasul de carte funciară?',
    answer: 'Extrasul are trei părți: partea I descrie imobilul (număr cadastral, suprafață, adresă, construcții), partea a II-a arată proprietarii și cotele lor, iar partea a III-a arată sarcinile: ipoteci, sechestre, servituți, interdicții de înstrăinare sau litigii notate.'
  },
  {
    question: 'Cât este valabil un extras de carte funciară?',
    answer: 'Extrasul pentru informare nu are un termen legal de valabilitate: arată situația imobilului la data și ora emiterii. În practică, băncile și alte instituții cer de obicei un extras emis recent, frecvent din ultimele 30 de zile, așa că verifică cerința instituției la care îl depui.'
  },
  {
    question: 'Care este diferența dintre extrasul CF și planul cadastral?',
    answer: 'Extrasul de carte funciară arată situația juridică (proprietari, sarcini, suprafață). Extrasul de plan cadastral pe ortofotoplan arată imobilul pe hartă, peste o fotografie aeriană, cu conturul și vecinătățile lui. Planul cadastral este util mai ales pentru terenuri.'
  },
  {
    question: 'Ce fac dacă nu știu numărul cadastral?',
    answer: 'Îl găsești de obicei în contractul de vânzare-cumpărare, în actul de moștenire, într-un extras de carte funciară mai vechi sau în documentația cadastrală a imobilului. Dacă ai doar un număr vechi de carte funciară, îl poți introduce pe acela.'
  },
  {
    question: 'Ce se întâmplă dacă am introdus un număr greșit?',
    answer: 'Formularul verifică formatul numărului înainte de plată, așa că multe greșeli sunt semnalate imediat. Dacă după plată documentul nu poate fi emis din cauza datelor, te contactăm pentru corectare sau îți returnăm banii.'
  },
  {
    question: 'Primesc factură?',
    answer: 'Da. Primești automat factura fiscală pe email, emisă de BITCRAFTERS SRL, pe persoană fizică sau pe firmă, după cum alegi în formular.'
  },
  {
    question: 'Sunteți ANCPI?',
    answer: 'Nu. CF-Extras.ro este un serviciu privat operat de BITCRAFTERS SRL. Ne ocupăm de comandă în locul tău și îți livrăm documentul oficial direct pe email, fără cont și fără deplasare.'
  },
  {
    question: 'Pot plăti cu cardul în siguranță?',
    answer: 'Da. Plata se face cu cardul (Visa, Mastercard) prin Stripe, un procesator de plăți certificat PCI-DSS. Noi nu vedem și nu stocăm datele cardului tău.'
  },
  {
    question: 'Cum vă pot contacta?',
    answer: 'Ne scrii oricând la contact@cf-extras.ro sau ne suni de luni până vineri, în timpul programului afișat în pagina de contact. Răspundem la orice întrebare despre comandă sau despre extras.'
  }
];

export default homeFaq;
